//const GoogleMaps = require('./../../../../global/js/modules/google-maps');
import {setupNewTooltips} from "../../../modules/hover-tooltips";

const VueUtils = require('../../../modules/vue-utils');

let $bookingApp, $vehicleFilter, $vehicleResults;

function _setupForVueApp() {
    $vehicleFilter = document.querySelector('.v-app[data-ref="vehicle-type-filter"]');
    $vehicleResults = document.querySelector('.v-app[data-ref="vehicle-results"]');

    if (!$vehicleFilter || !$vehicleResults) {
        console.warn('Unable to find filter or results components');
        return;
    }

    $bookingApp.addEventListener('vehicle-type-filter:search-started', event => {
        const resultContainer = VueUtils.getRef('vehicle-results');

        resultContainer.setBusy(event.detail && event.detail.message ? event.detail.message : true);
        if (!(event.detail && event.detail.partial)) {
            resultContainer.setResults(null);
        }

    });


    $bookingApp.addEventListener('vehicle-type-filter:search-completed', event => {
        const resultsContainer = VueUtils.getRef('vehicle-results');

        resultsContainer.setBusy(false);
        resultsContainer.setResults(event.detail);

        //update any tooltips
        setupNewTooltips();
    });

    $bookingApp.addEventListener('vehicle-type-results:requested-search', event => {
        const search = VueUtils.getRef('vehicle-type-filter');
        search.$_maybeAttemptSearch(true);
    });
}


document.addEventListener('DOMContentLoaded', () => {
    $bookingApp = document.querySelector('#booking-app');

    if (!document.querySelector('html.make-booking.select-vehicle') || !$bookingApp) {
        return;
    }

    _setupForVueApp();
});
